'use strict';

import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Front';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import BookingServicesInfosCard from 'Components/Front/BookingServicesInfosCard';
import PaymentSuccess from 'Components/Front/PaymentSuccess';
import Breadcrumb from 'Components/Front/Breadcrumb';
import StripeServicesForm from 'Components/Front/Booking/StripeServicesForm';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import MastercardIcon from 'Icons/Mastercard';
import CheckedIcon from 'Icons/Checked';
import VisaIcon from 'Icons/Visa';
import Loader from 'Pure/Loader';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import { num, isTrue } from 'Shared/utilities';
import { action, URL } from 'Shared/Routes';
const {
  app,
  qwest,
  moment
} = window;
function getToken() {
  let url = document.location.pathname;
  if (url.endsWith('/') && url !== '/') {
    url = url.slice(0, -1);
  }
  return url.slice(url.lastIndexOf('/') + 1);
}
export default class PayBookingServicesPage extends Component {
  state = {
    loading: true,
    status_messages: {},
    breadcrumb: [{
      name: 'home',
      url: URL('HomePage'),
      label: 'Accueil'
    }, {
      name: 'current-page',
      label: 'Paiement de services additionnels'
    }],
    token: getToken()
  };
  requests = {};
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.verifyToken();
  }
  verifyToken = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('verifyPayServicesToken'), {
      token: state.token,
      type: 'add-services'
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        booking: response.booking,
        booking_services: response.booking_services,
        paid: isTrue(response.booking_services?.paid),
        paid_now: false,
        ready: true
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleSuccess = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      paid: true,
      paid_now: true
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    moment.locale('fr');
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white']
    }) : undefined;
    const home_btn = !state.paid || state.paid_now ? undefined : /*#__PURE__*/React.createElement(Button, {
      type: "button",
      href: "/",
      className: bemit('c-arrow-btn', ['primary', 'big']) + ' u-margin-top-10'
    }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
      className: "c-arrow-btn__arrow"
    }), /*#__PURE__*/React.createElement("span", {
      className: "c-arrow-btn__text"
    }, "Revenir \xE0 l'accueil de myWO"));
    const paid_message = !state.paid ? undefined : state.paid_now ? /*#__PURE__*/React.createElement(PaymentSuccess, null) : /*#__PURE__*/React.createElement("div", {
      className: bemit('c-message', ['v2', 'green', 'align-left']) + ' u-margin-top-10'
    }, /*#__PURE__*/React.createElement(CheckedIcon, {
      className: "c-message__icon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Paiement valid\xE9 le", ' ', moment(state.booking_services?.paid_date).format('dddd DD MMMM YYYY [à] HH[h]mm') + '.'));
    const show_payment = !state.paid && state.ready && state.booking_services?.id ? true : false;
    const left_content = /*#__PURE__*/React.createElement(React.Fragment, null, paid_message, home_btn, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-margin-top-30"
    }, show_payment ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "payment-form__title"
    }, "Mode de paiment", /*#__PURE__*/React.createElement("p", {
      className: "payment-form__subtitle"
    }, "Toutes les transactions sont s\xE9curis\xE9es et chiffr\xE9es.")), /*#__PURE__*/React.createElement("div", {
      className: "payment-form__cc"
    }, /*#__PURE__*/React.createElement("div", {
      className: "payment-form__cc-title"
    }, "Carte de cr\xE9dit"), /*#__PURE__*/React.createElement("div", {
      className: "payment-form__cc-text"
    }, "Les moyens de paiement accept\xE9s"), /*#__PURE__*/React.createElement(VisaIcon, {
      className: "payment-form__cc-icon"
    }), /*#__PURE__*/React.createElement(MastercardIcon, {
      className: "payment-form__cc-icon"
    }))) : undefined, show_payment ? /*#__PURE__*/React.createElement(StripeServicesForm, {
      id: state.booking_services.id,
      booking_services_token: state.token,
      amount: num(state.booking_services.amount),
      onPaymentSuccess: component.handleSuccess
    }) : undefined), getFormStatus(state, ['v2']));
    const page_content = /*#__PURE__*/React.createElement("div", {
      className: "add-booking-services-container"
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      links: state.breadcrumb,
      bemit: ['no-padding'],
      className: "u-margin-bottom-10"
    }), /*#__PURE__*/React.createElement("div", {
      className: "add-booking-services-container__content"
    }, left_content, loader), /*#__PURE__*/React.createElement("div", {
      className: "add-booking-services-container__infos"
    }, /*#__PURE__*/React.createElement(BookingServicesInfosCard, {
      booking: state.booking,
      booking_services: state.booking_services
    })));
    let output = /*#__PURE__*/React.createElement(Layout, props, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['primary-bg'])
    }), /*#__PURE__*/React.createElement("div", {
      className: "page-container"
    }, page_content));
    return output;
  }
}
